import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import VenuePromotionRequestListLayer from "../../components/VenuePromotionRequest/VenuePromotionRequestListLayer";

const EventPromotionRequestList = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Event Promotion Request" />
      <VenuePromotionRequestListLayer requestType="event" />
    </MasterLayout>
  );
};

export default EventPromotionRequestList;
